"use client"

import { twc } from "react-twc"

export const Container = twc.div`flex flex-col items-center box-border`

export const Content = twc.div`max-w-8xl container`

export const ContentMedium = twc.div`max-w-7xl mx-5 lg:mx-36`
export const ContentSmall = twc.div`max-w-[800px] mx-5 lg:mx-36`
